import {DateTime} from 'luxon';


// An object representing a period, with s and e being start and end times (in minutes after 12:00 AM PST)
// and n being the period's key. 0-8 represent periods 0 through 8, while B, L, S, H, and P represent Brunch, Lunch, SELF,
// Study Hall, and PRIME, respectively. G and O represent the now deprecated Gunn Together and Office Hours periods. All other period
// names, like "ELA CAT", remain unparsed.
export type PeriodObj = {n: string, s: number, e: number, note?: string, grades?: number[]};

export const SCHOOL_START = DateTime.fromISO('2026-08-13', {zone: 'America/Los_Angeles'});
export const SCHOOL_END = DateTime.fromISO('2027-06-03', {zone: 'America/Los_Angeles'});
export const SCHOOL_END_EXCLUSIVE = DateTime.fromISO('2027-06-05', {zone: 'America/Los_Angeles'});

const schedule: {[key: string]: PeriodObj[]} = {
    "M": [
        {
            "n": "0",
            "s": 475,
            "e": 530
        },
        {
            "n": "1",
            "s": 540,
            "e": 590
        },
        {
            "n": "2",
            "s": 597,
            "e": 642
        },
        {
            "n": "B",
            "s": 642,
            "e": 650
        },
        {
            "n": "3",
            "s": 657,
            "e": 702
        },
        {
            "n": "4",
            "s": 709,
            "e": 754
        },
        {
            "n": "L",
            "s": 754,
            "e": 784
        },
        {
            "n": "5",
            "s": 791,
            "e": 836
        },
        {
            "n": "6",
            "s": 843,
            "e": 888
        },
        {
            "n": "7",
            "s": 895,
            "e": 940
        }
    ],
    "T": [
        {
            "n": "0",
            "s": 475,
            "e": 530
        },
        {
            "n": "1",
            "s": 540,
            "e": 630
        },
        {
            "n": "B",
            "s": 630,
            "e": 638
        },
        {
            "n": "2",
            "s": 645,
            "e": 735
        },
        {
            "n": "L",
            "s": 735,
            "e": 765
        },
        {
            "n": "3",
            "s": 772,
            "e": 862
        },
        {
            "n": "4",
            "s": 869,
            "e": 959
        }
    ],
    "W": [
        {
            "n": "0",
            "s": 475,
            "e": 530
        },
        {
            "n": "5",
            "s": 540,
            "e": 630
        },
        {
            "n": "B",
            "s": 630,
            "e": 638
        },
        {
            "n": "6",
            "s": 645,
            "e": 735
        },
        {
            "n": "L",
            "s": 735,
            "e": 765
        },
        {
            "n": "7",
            "s": 772,
            "e": 862
        },
        {
            "n": "P",
            "s": 869,
            "e": 919
        }
    ],
    "R": [
        {
            "n": "0",
            "s": 475,
            "e": 530
        },
        {
            "n": "1",
            "s": 540,
            "e": 630
        },
        {
            "n": "B",
            "s": 630,
            "e": 638
        },
        {
            "n": "2",
            "s": 645,
            "e": 735
        },
        {
            "n": "L",
            "s": 735,
            "e": 765
        },
        {
            "n": "3",
            "s": 772,
            "e": 862
        },
        {
            "n": "4",
            "s": 869,
            "e": 959
        }
    ],
    "F": [
        {
            "n": "5",
            "s": 540,
            "e": 630
        },
        {
            "n": "B",
            "s": 630,
            "e": 638
        },
        {
            "n": "6",
            "s": 645,
            "e": 735
        },
        {
            "n": "L",
            "s": 735,
            "e": 765
        },
        {
            "n": "S",
            "s": 772,
            "e": 802,
            "grades": [9, 10]
        },
        {
            "n": "H",
            "s": 772,
            "e": 802,
            "grades": [11, 12]
        },
        {
            "n": "S",
            "s": 809,
            "e": 839,
            "grades": [11, 12]
        },
        {
            "n": "H",
            "s": 809,
            "e": 839,
            "grades": [9, 10]
        },
        {
            "n": "7",
            "s": 846,
            "e": 936
        }
    ]
}
export default schedule;
